<!--区域限速-->

<template>
  <div>
    <limitareaset />
  </div>
</template>
<script>
import limitareaset from "./components/limitareaset";
export default {
    name:"arealimit",
  components: {
    limitareaset,
  },
  mounted() {
    this.$store.dispatch("app/closeSideBar");
  },
  destroyed() {
    this.$store.dispatch("app/openSideBar");
  },
};
</script>
